import React from 'react';
import Chart from 'react-apexcharts';

export const DashTasksStackedAreaChart = ({ data }) => {
  if (!data) return null;

  // Transform the data for columns chart
  const transformDataForColumns = () => {
    const values = data.find(item => item.property === 'Valores');
    const quantities = data.find(item => item.property === 'Quantidade');
    
    if (!values || !quantities) return [];

    return [
      {
        name: 'Abertura',
        data: [values.opening],
        color: '#52c41a',
        quantity: quantities.opening
      },
      {
        name: 'Alteração',
        data: [values.changing],
        color: '#faad14',
        quantity: quantities.changing
      },
      {
        name: 'Encerramento',
        data: [values.closing],
        color: '#595959',
        quantity: quantities.closing
      },
      {
        name: 'Troca de contabilidade',
        data: [values.account_change],
        color: '#f5222d',
        quantity: quantities.account_change
      }
    ];
  };

  const series = transformDataForColumns();

  const options = {
    chart: {
      type: 'bar',
      height: 350,
      stacked: false,
      toolbar: {
        show: false
      },
      zoom: {
        enabled: false
      }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '90%',
        endingShape: 'rounded'
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: '12px',
        fontWeight: 'normal'
      },
      formatter: function(value, { seriesIndex }) {
        const item = series[seriesIndex];
        const amount = new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(value);
        return `${amount}\n(${item.quantity})`;
      }
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      categories: ['Serviços Extras / Tarefas'],
      labels: {
        show: false
      }
    },
    yaxis: {
      labels: {
        formatter: function(value) {
          return new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(value);
        }
      }
    },
    tooltip: {
      y: {
        formatter: function(value, { seriesIndex }) {
          const item = series[seriesIndex];
          const amount = new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(value);
          return `${amount} (${item.quantity})`;
        }
      }
    },
    legend: {
      position: 'bottom'
    },
    colors: series.map(item => item.color)
  };

  return (
    <Chart
      options={options}
      series={series}
      type="bar"
      height={350}
    />
  );
}; 